import React from "react";

const Galvao = () => {
  return (
    <section>
    
      <iframe src="https://app.powerbi.com/view?r=eyJrIjoiNjBiZDQyMDQtNjVkZC00Nzg2LWI5MDktMGEyODFkNjIxOWFhIiwidCI6ImYyMzQ4MWYzLTI2ZGItNGZjOC1hNzliLTFiZTk2ZWZjMzg4YyIsImMiOjR9" frameborder="0" allowFullScreen="true"></iframe>
    </section>
  );
};

export default Galvao;
